import { useTraffic, useHourly, useReleaseBands } from '../lib/api-client'
import { LoadingCard } from '../components/LoadingSpinner'
import { TrafficOverviewChart } from '../components/charts/TrafficOverviewChart'
import { HourlyPatternChart } from '../components/charts/HourlyPatternChart'
import { useDateRange } from '../components/Layout'
import { StatCard, ChartCard } from '../components/ui'

export function Traffic() {
  const { startDate, endDate, granularity } = useDateRange()

  const traffic = useTraffic(startDate, endDate, granularity)
  const releaseBands = useReleaseBands(startDate, endDate)
  const hourly = useHourly(startDate, endDate)

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-foreground">Traffic Analysis</h2>

      {/* Main Traffic Chart */}
      <ChartCard title="Page Views & Visitors Over Time">
        {traffic.isLoading ? (
          <LoadingCard />
        ) : traffic.data ? (
          <div className="h-[400px]">
            <TrafficOverviewChart
              data={traffic.data.data}
              releaseBands={releaseBands.data?.data}
            />
          </div>
        ) : (
          <p className="text-muted-foreground">No data available</p>
        )}
      </ChartCard>

      {/* Hourly Pattern */}
      <ChartCard title="Hourly Activity Pattern">
        {hourly.isLoading ? (
          <LoadingCard />
        ) : hourly.data ? (
          <HourlyPatternChart data={hourly.data.data} />
        ) : (
          <p className="text-muted-foreground">No data available</p>
        )}
      </ChartCard>

      {/* Stats Summary */}
      {traffic.data && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <StatCard
            title="Total Page Views"
            value={traffic.data.data.reduce((sum, d) => sum + d.page_views, 0)}
          />
          <StatCard
            title="Avg Daily Views"
            value={Math.round(
              traffic.data.data.reduce((sum, d) => sum + d.page_views, 0) /
                Math.max(traffic.data.data.length, 1)
            )}
          />
          <StatCard
            title="Peak Day Views"
            value={Math.max(...traffic.data.data.map((d) => d.page_views), 0)}
          />
        </div>
      )}
    </div>
  )
}
